import { FC } from 'react'
import {
  FinanceCalculatorThemeProvider,
  usePlatformConfig,
  Widgets,
} from '@dxp-module/common'
import MiniFcWidgetButton from './components/widgetButton/MiniFcWidgetButton'

const MiniFcWidgetContent: FC = () => {
  const {
    platformConfig: {
      themeOverride,
      financeCalculator: { disableCssBaseline },
    },
  } = usePlatformConfig()

  return (
    <FinanceCalculatorThemeProvider
      themeOverride={themeOverride}
      widget={Widgets.MINI_FINANCE_CALCULATOR}
      disableCssBaseline={disableCssBaseline}
    >
      <MiniFcWidgetButton />
    </FinanceCalculatorThemeProvider>
  )
}

export default MiniFcWidgetContent
